/**
 * @file Focus
 */
'use strict'

import Common from '../../Utils/Common'

/**
 * @classname Focus
 * @classdesc faqページでアコーディオンがアンカー指定されていたら、そのdtをopenする
 */
export default class Focus {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('Focus.constructor')

		const url = new URL(window.location.href)
		const anchor = url.hash
		const selector = $(anchor)
		const element = selector.get(0)

		if (element && selector.is('dt')) {
			selector.click()
		}
	}
}
